import { render, staticRenderFns } from "./payPass.vue?vue&type=template&id=95f35498&scoped=true"
import script from "./payPass.vue?vue&type=script&lang=js"
export * from "./payPass.vue?vue&type=script&lang=js"
import style0 from "./payPass.vue?vue&type=style&index=0&id=95f35498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f35498",
  null
  
)

export default component.exports